<template>
  <template v-if="pageContent.sections && pageContent.sections.length">
    <template v-for="(section, i) of pageContent.sections" :key="i">
      <template v-if="typeof section === 'number'" />

      <PageSection
        v-else-if="
          section.collection &&
          section.item &&
          typeof section.item === 'object' &&
          section.item.status === 'published'
        "
        :ref="el => setSectionRef(section.item, el)"
        :collection="section.collection"
        :item="/** @type {object} **/ (section.item)"
      />
    </template>
  </template>
</template>

<script setup>
import { onMounted } from 'vue'
import { useProvideSectionRefs, useSectionRefs } from '#root/lib/useSectionRefs'
import { scrollToRefKey, slugify } from '#root/lib/utils'

defineProps({
  pageContent: {
    required: true,
    type: Object
  }
})

useProvideSectionRefs()

const { sectionsRefs } = useSectionRefs()

function setSectionRef(key, el) {
  const slug = slugify(key)
  sectionsRefs[slug] = el
}

onMounted(async () => {
  await scrollToRefKey(sectionsRefs, undefined, { delay: true })
})
</script>
